export class Limits {
    public static readonly MaxRowCol = 16;
    public static readonly MaxRandomCount = 8;
    public static readonly MaxPadding = 8.0;
}